// Module
var code = `<ng-form name="\$ctrl.form">
  <validator condition="\$ctrl.hasValidIncomeSources()"></validator>
  <div class="total-income" ng-if="\$ctrl.profile.customerType === 'INDIVIDUAL'">
    <form-section-field field-title="'Total monthly income amount (Estimate)'"
                        ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'personal_data', 'total_annual_income')">
      <cash ng-required="\$ctrl.cfg.required(\$ctrl.module, 'personal_data', 'total_annual_income')"
            ng-model="\$ctrl.totalMonthlyIncome"
            ng-disabled="true"></cash>
    </form-section-field>
    <form-section-field field-title="'Total annual income amount (Estimate)'"
                        ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'personal_data', 'total_annual_income')">
      <cash ng-required="\$ctrl.cfg.required(\$ctrl.module, 'personal_data', 'total_annual_income')"
            ng-model="\$ctrl.profile.individualData.totalAnnualIncome"
            ng-disabled="true"></cash>
    </form-section-field>
  </div>

  <div class="total-income" ng-if="\$ctrl.profile.customerType === 'CORPORATE'">
    <form-section-field field-title="'Total monthly income amount (Estimate)'"
                        ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'corporate', 'total_annual_income')">
      <cash ng-required="\$ctrl.cfg.required(\$ctrl.module, 'corporate', 'total_annual_income')"
            ng-model="\$ctrl.totalMonthlyIncome"
            ng-disabled="true"></cash>
    </form-section-field>
    <form-section-field field-title="'Total annual income amount (Estimate)'"
                        ng-if="\$ctrl.cfg.visible(\$ctrl.module, 'corporate', 'total_annual_income')">
      <cash ng-required="\$ctrl.cfg.required(\$ctrl.module, 'corporate', 'total_annual_income')"
            ng-model="\$ctrl.profile.corporateData.totalAnnualIncome"
            ng-disabled="true"></cash>
    </form-section-field>
  </div>

  <div id="cpr_inc_income_sources">
    <div class="form-column" ng-repeat="soi in \$ctrl.profile.incomeSources">

      <common-income-source
        income-form-title="'Income ' + (\$index + 1) + ' details'"
        company-form-title="'Business ' + (\$index + 1) + ' details'"
        employment-form-title="'Employer ' + (\$index + 1) + ' details'"
        performance-form-title="'Performance ' + (\$index + 1) + ' details'"
        edit-mode="\$ctrl.editMode"
        remove-income-source="\$ctrl.removeIncomeSource(soi)"
        has-one-primary-income-source="\$ctrl.hasOnePrimaryIncomeSource()"
        primary-income-source-changed="\$ctrl.primaryIncomeSourceChanged(soi, \$index)"
        source-of-income="soi"
        ng-if="!['DEPED', 'OTHER_BANK_ACCOUNTS', 'SSS'].includes(soi.type)"
        module="\$ctrl.module">
      </common-income-source>

      <dep-ed-income-source
        income-form-title="'Income ' + (\$index + 1) + ' details: (DEPED)'"
        edit-mode="\$ctrl.editMode"
        remove-income-source="\$ctrl.removeIncomeSource(soi)"
        has-one-primary-income-source="\$ctrl.hasOnePrimaryIncomeSource()"
        primary-income-source-changed="\$ctrl.primaryIncomeSourceChanged(soi, \$index)"
        source-of-income="soi"
        ng-if="soi.type === 'DEPED'">
      </dep-ed-income-source>

      <sss-income-source
        customer-id="\$ctrl.profile.id"
        income-form-title="'Income ' + (\$index + 1) + ' details: (SSS)'"
        edit-mode="\$ctrl.editMode"
        remove-income-source="\$ctrl.removeIncomeSource(soi)"
        has-one-primary-income-source="\$ctrl.hasOnePrimaryIncomeSource()"
        primary-income-source-changed="\$ctrl.primaryIncomeSourceChanged(soi, \$index)"
        source-of-income="soi"
        ng-if="soi.type === 'SSS'">
      </sss-income-source>

      <other-bank-accounts-income-source
        income-form-title="'Income ' + (\$index + 1) + ' details: (Other bank accounts)'"
        edit-mode="\$ctrl.editMode"
        remove-income-source="\$ctrl.removeIncomeSource(soi)"
        has-one-primary-income-source="\$ctrl.hasOnePrimaryIncomeSource()"
        primary-income-source-changed="\$ctrl.primaryIncomeSourceChanged(soi, \$index)"
        source-of-income="soi"
        ng-if="soi.type === 'OTHER_BANK_ACCOUNTS'"
        module="\$ctrl.module">
      </other-bank-accounts-income-source>

    </div>

  </div>

  <div class="form-column" ng-show="\$ctrl.editMode">
    <form name="additional_income_source">
      <form-section form-title="'Add new income source'">
        <form-section-field field-title="'Income source'">
          <select type="text"
                  ng-model="\$ctrl.incomeSourceType"
                  ng-disabled="!\$ctrl.editMode"
                  ng-options="entry.code as entry.description for entry in \$ctrl.types">
            <option></option>
          </select>
        </form-section-field>
      </form-section>
      <div ng-show="\$ctrl.editMode">
        <button ng-click="\$ctrl.addIncomeSource(\$ctrl.incomeSourceType)"
                class="btn btn-primary btn--align-with-form-field" type="button"
                ng-disabled="!\$ctrl.incomeSourceType">
          Add source of income
        </button>
      </div>
    </form>
  </div>

  <!-- income source count validation -->
  <div ng-if="\$ctrl.profile.incomeSources.length < \$ctrl.minSections">
    <input class="hidden-element" disabled ng-required="true" ng-model="nonExistingValue"/>
  </div>

</ng-form>

<div class="clearfix"></div>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/shared/customer-profile-commons/income-source/income.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;